export default "__VITE_ASSET__400d0550__"